import instance from 'utils/axios/instance.axios';
import { REVIEWS } from './_constant';

export const getReviewsDetail = (councilMemberId, projectProposalId, councilId) =>
  instance.get(REVIEWS.GET_REVIEWS_DETAIL, {
    params: {
      councilMemberId,
      projectProposalId,
      councilId,
    },
  });

export const getReviewerInfo = (projectProposalId, councilMemberId, councilId) =>
  instance.get(REVIEWS.GET_REVIEWER_INFO, {
    params: {
      projectProposalId,
      councilMemberId,
      councilId,
    },
  });

export const createReviews = (body = {}) => instance.post(REVIEWS.CREATE_REVIEW, body);

export const updateReviews = (body = {}) => instance.patch(REVIEWS.UPDATE_REVIEW, body);

export const submitReviews = (body = {}) => instance.patch(REVIEWS.SUBMIT_REVIEW, body);

export const downloadDocxFile = (body = {}) =>
  instance.post(REVIEWS.DOWNLOAD_DOCX_FILE, body, {
    responseType: 'blob',
  });

export const downloadDocxTemplate = (body = {}) =>
  instance.post(REVIEWS.DOWNLOAD_DOCX_TEMPLATE, body, {
    responseType: 'blob',
  });

export const downloadPdfFile = (body = {}) =>
  instance.post(REVIEWS.DOWNLOAD_PDF_FILE, body, {
    responseType: 'blob',
  });

export const downloadPdfTemplate = (body = {}) =>
  instance.post(REVIEWS.DOWNLOAD_PDF_TEMPLATE, body, {
    responseType: 'blob',
  });
